import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { PendingRequest } from '../modal/pendingrequest';

@Injectable({
    providedIn: 'root'
})

export class PendingRequestService {
    constructor(private httpclient: HttpClient, private global: Globals) {
    }

  
    GetPendingRequest() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/emailData/getAllByUserId/"+this.global.loggedUser.user.user_reg_id, { headers:headers });
        
    }

    GetAllSubject() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/subject", { headers: headers });
    }

    GetAllSpecification() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/specification", { headers: headers });
    }

    GetAllRemark() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/remark", { headers: headers });
    }

    AcceptPendingRequest(pendingRequest: PendingRequest) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        debugger;
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail", {
            "senderID": pendingRequest.senderId,
            "ccId": pendingRequest.ccId,
            "toId": pendingRequest.toId,
            "body": pendingRequest.body,
            "date_time": pendingRequest.dateTime,
            "amount": pendingRequest.amount,
            "hide": pendingRequest.hide,
            "star": pendingRequest.star,
            "deleted": false,
            "extra1": "",
            "extra2": "",
            "email_Id": pendingRequest.emailData_Id,
            "user_id": pendingRequest.user_id,
            "attachment": pendingRequest.attachment,
            "sub": pendingRequest.sub,
            "spec": pendingRequest.spec,
            "remark": pendingRequest.remark
        }, { headers:headers });
    }

    DeclineRequest(id: any) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.delete(this.global.G_apiUrl + '/emailData/' + id,
        {responseType:'text', headers: headers});
    }


    multipleApproved(approvedList){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        debugger;
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleApproved",approvedList , { headers:headers });
    }
    multipleDecline(approvedList){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        debugger;
        return this.httpclient.post(this.global.G_apiUrl + "/emailData/multipleDecline",approvedList , {responseType:'text', headers:headers });
    }

}
